/**
 * Wrapper de ruta protegida. Verifica autenticación.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingSpinner } from '@/components/shared/feedback/Feedback';
import { MainLayout } from '@/components/shared/layout/MainLayout/MainLayout';
import type { ReactNode } from 'react';
import type { Crumb } from '@/components/shared/navigation/Breadcrumb';

type Props = { children: ReactNode; crumbs?: Crumb[]; requiredPermission?: string; rightSlot?: ReactNode };

export function ProtectedRoute({ children, crumbs, requiredPermission, rightSlot }: Props) {
  const { isAuthenticated, isLoading, hasPermission } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingSpinner size="lg" />;
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <MainLayout crumbs={crumbs} rightSlot={rightSlot}>{children}</MainLayout>;
}
